import { vFocus, vEnter } from 'commons/utils'

// 控制Modal组件Mask层的显示
const vMask = {
  update (el, {value}) {
    let mask = el.querySelector('[class*="mask"]')
    if (mask) {
      mask.style.display = value ? '' : 'none'
    }
  }
}

// 失效Affix组件
const vFix = {
  update (el, {value}) {
    (el.firstElementChild || el.firstChild).style.position = value ? '' : 'static';
    (el.lastElementChild || el.lastChild).style.position = value ? '' : 'absolute';
    (el.lastElementChild || el.lastChild).style.top = value ? '' : '-1000px'
  }
}

export {
  vFocus,
  vEnter,
  vMask,
  vFix
}



// WEBPACK FOOTER //
// ./src/plugins/Directives.js